import { and, any, complement, pipe, props } from 'ramda';

const preMatchListPageNames = [
  'preMatchFavorites',
  'preMatchSport',
  'preMatchCategory',
  'preMatchTournament',
  'preMatchFilter',
  'customFilter'
];

const topEventsListPageNames = ['topEvents'];

const liveListPageNames = ['liveFavorites', 'liveSport', 'liveSportAll'];

const cyberSportListPages = [
  'cyberSport',
  'cyberSportCategory',
  'cyberSportTournament',
  'cyberSportFavorites'
];

const listPageNames = [
  ...preMatchListPageNames,
  ...topEventsListPageNames,
  ...liveListPageNames,
  ...cyberSportListPages
];

export const isDetailsPage = (pathname = '', routes) =>
  [routes.preMatchEvent, routes.liveEvent].some((pagePath) =>
    pathname.startsWith(pagePath)
  );

const isPageOfType = (pageNames) => (pathname, routes) =>
  pipe(
    props(pageNames),
    any((page) => pathname.startsWith(page))
  )(routes);

export const isListPage = and(
  isPageOfType(listPageNames),
  complement(isDetailsPage)
);

export const isPreMatchSportsPage = (pathname, routes) =>
  pathname.startsWith(routes.preMatchSport);

export const isLiveListPage = isPageOfType(liveListPageNames);
